'use client';

import { useEffect } from 'react';
import { getThemeConfig } from '#/lib/theme-config';

export default function CustomSettings({theme}: {theme: string}) {

  useEffect(() => {
    const settings = document.querySelector('[data-ghost-custom-settings]')
    const wrapper = document.querySelector('[data-settings-placeholder]');

    if (settings && wrapper) {
      wrapper.append(settings)
      settings.classList.remove('hidden')
      settings.classList.add('flex')
    }
  }, []);

  const settings = getThemeConfig(theme)[0]?.config?.custom

  if (!settings) {
    return <></>
  }

  return (

    <div className="max-w-sm hidden flex-col gap-8 border-2 border-accent-brd px-5 py-4 pb-6 rounded-md" data-ghost-custom-settings='site-wide'>
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex gap-2" aria-label="Tabs">
          <button className="border-transparent hover:border-gray-300 whitespace-nowrap border-b-4 py-2 px-1 text-sm font-normal opacity-70" 
            onClick={() => { document.querySelector('[data-ghost-custom-settings]')?.setAttribute('data-ghost-custom-settings', 'site-wide') }}
            data-category="site-wide"
          >
              Site wide
          </button>
          <button className="border-transparent hover:border-gray-300 whitespace-nowrap border-b-4 py-2 px-1 text-sm font-normal opacity-70"
            onClick={() => { document.querySelector('[data-ghost-custom-settings]')?.setAttribute('data-ghost-custom-settings', 'homepage')  }} 
            data-category="homepage"
          >
              Homepage
          </button>
          <button className="border-transparent hover:border-gray-300 whitespace-nowrap border-b-4 py-2 px-1 text-sm font-normal opacity-70"
            onClick={() => { document.querySelector('[data-ghost-custom-settings]')?.setAttribute('data-ghost-custom-settings', 'post')  }}
            data-category="post"
          >
              Post
          </button>
        </nav>
      </div>

      {Object.keys(settings).map(setting => {
        const type = settings[setting].type
        const defaultValue = settings[setting].default
        const group = settings[setting].group
        const options = settings[setting].options
        const description = settings[setting].description

        return(
          <label className="relative flex-col gap-1.5 hidden" key={setting} data-setting-type={type} data-setting-category={group ? group : 'site-wide'}>
            {/* title */}
            <span className="text-sm leading-none font-normal first-letter:capitalize">{setting.replaceAll('_', ' ')}</span>

            {/* Text type */}
            {type === 'text' &&
              <input className="bg-gray-100 rounded-md text-[0.9rem] px-3 py-1"/>
            }

            {/* Boolean type */}
            {type === 'boolean' &&
              <input className="absolute right-0 checked:bg-black appearance-none rounded-full bg-gray-300 transition after:absolute after:ml-0.5 after:mt-0.5 after:rounded-full after:border-none after:bg-white after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:after:absolute checked:after:rounded-full checked:after:border-none checked:after:bg-white checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] enabled:hover:cursor-pointer disabled:opacity-40 enabled:group-hover:opacity-80  min-w-[28px] h-4 w-7 after:h-3 after:w-3 checked:after:ml-[14px]  order-2" role="switch" type="checkbox" data-value={defaultValue} defaultChecked={defaultValue}/>
            }

            {/* Color type */}
            {type === 'color' &&
              <div className="absolute right-0 rounded-full w-6 h-6 border-accent-brd bg-[conic-gradient(hsl(360,100%,50%),hsl(315,100%,50%),hsl(270,100%,50%),hsl(225,100%,50%),hsl(180,100%,50%),hsl(135,100%,50%),hsl(90,100%,50%),hsl(45,100%,50%),hsl(0,100%,50%))]">
                <input type="color" className="absolute w-[18px] h-[18px] top-[3px] right-[3px] rounded-full p-0" defaultValue={settings[setting].default}/>
              </div>
            }

            {/* Select type */}
            {type === 'select' &&
              <select className="bg-accent-bg-2 text-[0.9rem] p-2 border border-accent-brd font-light rounded-md w-full"
                defaultValue={defaultValue}>
                {options?.map((option: string) => 
                  <option key={option}>{option}</option>
                )}
              </select>
            }

            {/* Image type */}
            {type === 'image' &&
              <button className="bg-gray-100 rounded-md text-[0.9rem] px-3 py-1 mt-4 font-normal text-gray-500 hover:text-accent-txt-1">Upload image</button>
            }

            {/* description */}
            {description && 
              <span className="text-sm leading-none opacity-80 pr-12">{description}</span>
            }
          </label>
        )
      })}
    </div>
  )
}